import React from "react";
import { Box, Container, Grid } from '@mui/material';
import { createStyles } from "@material-ui/styles";
import { withStyles, Toolbar, Button } from "@material-ui/core";
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemePicker } from '../mui-theme-design';
import Typography from '@mui/material/Typography';
import moment from "moment";
 

const MyToolbar = ({ setOpenView, date }) => {
    const today = moment(date);

    var weeknumber = today.week();
    var year = today.year();
    var month = today.format("MMM");

    const fromDate = today.startOf("week").date();
    const toDate = today.endOf("week").date();

    return (
        <MuiThemeProvider theme={muiThemePicker}>
            <Toolbar >
                <Box sx={{ width: 300, height: 60, alignItems: 'center'  }}>
                    <Button variant="outlined" onClick={e => setOpenView("year")}>
               
                        <Typography sx={{ color: '#ffffff', width: '120' }} >
                        {year} Week {weeknumber}
                    </Typography>
               
            </Button> 
                    <Button variant="outlined" onClick={e => setOpenView("date")}>
               
                        <Typography sx={{ varient:'h4', color: '#ffffff' ,fontWeight: 'bold', width:'140' }}>
                        {month} {fromDate} to {toDate}
                    </Typography>
               
               
                    </Button>
            </Box>
            </Toolbar>
            </MuiThemeProvider>
    );
};

export default  (MyToolbar);